const SESSION_KEY = "jj_selected_category";

/**
 * Verifica se um campo category (string ou array) contém o valor especificado.
 */
export function categoryContains(
  category: string | string[] | undefined,
  value: string
): boolean {
  if (!category) return false;
  if (Array.isArray(category)) return category.includes(value);
  return category === value;
}

/**
 * Retorna true se o category contém AMBOS "CONEXAO" e "JJ_PREDEFINIDO".
 */
export function isDualCategory(
  category: string | string[] | undefined
): boolean {
  if (!Array.isArray(category)) return false;
  return category.includes("CONEXAO") && category.includes("JJ_PREDEFINIDO");
}

/**
 * Retorna a categoria efetiva do usuario.
 * - Se dual-category: retorna a escolha salva em sessionStorage
 * - Se single: retorna o valor diretamente (string ou primeiro item relevante do array)
 * - Retorna null se dual e sem escolha salva
 */
export function getEffectiveCategory(user: any): string | null {
  const category = user?.extra?.category;

  if (isDualCategory(category)) {
    return sessionStorage.getItem(SESSION_KEY);
  }

  if (Array.isArray(category)) {
    if (category.includes("JJ_PREDEFINIDO")) return "JJ_PREDEFINIDO";
    if (category.includes("CONEXAO")) return "CONEXAO";
    return category[0] || null;
  }

  return category || null;
}

export function setSelectedCategory(category: string): void {
  sessionStorage.setItem(SESSION_KEY, category);
}

export function clearSelectedCategory(): void {
  sessionStorage.removeItem(SESSION_KEY);
}
